import { FirestoreDatabaseService } from '../shared/FirestoreDatabase';

const TABLE_NAME = '/relations';

export class RelationsFirebaseService extends FirestoreDatabaseService {
  constructor() {
    super(TABLE_NAME);
  }
}
